// extracted by mini-css-extract-plugin
module.exports = {"container":"social-proof_container__3zodi","avatar":"social-proof_avatar__h0iAu","text":"social-proof_text__9NEy3"};